import { apiClient } from './api';
import type { SeasonParticipation, PendingApproval, ApiResponse } from '@/types';

const realSeasonParticipationService = {
  requestParticipation: async (seasonId: string): Promise<SeasonParticipation> => {
    const response = await apiClient.post<ApiResponse<SeasonParticipation>>(
      '/api/v1/seasonparticipation/request',
      { seasonId }
    );
    return response.data.data!;
  },

  approveParticipation: async (
    participationId: string,
    isApproved: boolean
  ): Promise<SeasonParticipation> => {
    const response = await apiClient.post<ApiResponse<SeasonParticipation>>(
      '/api/v1/seasonparticipation/approve',
      {
        participationId,
        isApproved,
      }
    );
    return response.data.data!;
  },

  getPendingApprovals: async (seasonId?: string): Promise<PendingApproval[]> => {
    const params = seasonId ? { seasonId } : {};
    const response = await apiClient.get<ApiResponse<PendingApproval[]>>(
      '/api/v1/seasonparticipation/pending',
      { params }
    );
    return response.data.data!;
  },

  getMyParticipations: async (): Promise<SeasonParticipation[]> => {
    const response = await apiClient.get<ApiResponse<SeasonParticipation[]>>(
      '/api/v1/seasonparticipation/my-participations'
    );
    return response.data.data!;
  },

  checkParticipation: async (seasonId: string): Promise<boolean> => {
    const response = await apiClient.get<ApiResponse<boolean>>(
      '/api/v1/seasonparticipation/check',
      { params: { seasonId } }
    );
    return response.data.data!;
  },

  getParticipation: async (seasonId: string): Promise<SeasonParticipation> => {
    const response = await apiClient.get<ApiResponse<SeasonParticipation>>(
      '/api/v1/seasonparticipation/participation',
      { params: { seasonId } }
    );
    return response.data.data!;
  },

  // Admin: all participations for a season (approved + pending), with per-season payment.
  getSeasonParticipants: async (seasonId: string): Promise<SeasonParticipation[]> => {
    const response = await apiClient.get<ApiResponse<SeasonParticipation[]>>(
      '/api/v1/seasonparticipation/participants',
      { params: { seasonId } }
    );
    return response.data.data!;
  },

  // Admin: set a participant's per-season payment status.
  updateParticipationPayment: async (
    participationId: string,
    isPaid: boolean
  ): Promise<SeasonParticipation> => {
    const response = await apiClient.patch<ApiResponse<SeasonParticipation>>(
      `/api/v1/seasonparticipation/${participationId}/payment`,
      { isPaid }
    );
    return response.data.data!;
  },
};

export const seasonParticipationService = realSeasonParticipationService;
